import React from 'react'
import { InputGroup } from 'react-bootstrap'
import CurrencyInput from 'react-currency-input-field'
import { Controller, useWatch } from 'react-hook-form'
import { usdCurrencyFormat } from 'resources/functions'
import { currencyFormat } from 'resources/helper'

const BudgetRow = React.memo(function BudgetRow({
  rowIndex,
  data,
  control,
  tableHeaders,
  isReadOnly,
  isSelected,
  onSelectRow,
  onValueChange,
  errors,
  totalAmount,
  bgColor = '#fff',
  style, // <-- Accepted here
}: any) {
  const rowValues = useWatch({ control, name: `budgets.${rowIndex}` })

  const rowTotal = React.useMemo(() => {
    if (!rowValues) return 0
    return Object.keys(rowValues).reduce((acc, key) => {
      if (key.startsWith('month_')) {
        const raw = rowValues[key]?.amount
        const n = parseFloat(String(raw ?? '0').replace(/,/g, ''))
        return acc + (isFinite(n) ? n : 0)
      }
      return acc
    }, 0)
  }, [rowValues])

  return (
    <div
      className="v-table-row align-items-center"
      style={{ ...style, backgroundColor: bgColor }}
    >
      {!isReadOnly && (
        <div
          className="v-table-cell v-sticky-left-1 d-flex align-items-center justify-content-center"
          style={{ width: '40px', minWidth: '40px', backgroundColor: bgColor }}
        >
          <div className="form-check m-0">
            <input
              type="checkbox"
              className="form-check-input wh-20"
              checked={isSelected}
              onChange={() => onSelectRow(rowIndex)}
            />
          </div>
        </div>
      )}
      <div
        className="v-table-cell v-sticky-left-2 d-flex align-items-center px-2"
        style={{
          left: isReadOnly ? 0 : '40px',
          width: '240px',
          minWidth: '240px',
          backgroundColor: '#FFFFFF',
        }}
      >
        <span
          className="text-truncate d-block fw-medium"
          title={`${data.master_chart_of_account_number} ${data.master_chart_of_account_name}`}
        >
          {data.master_chart_of_account_number} -{' '}
          {data.master_chart_of_account_name}
        </span>
      </div>

      {tableHeaders.map((_: any, colIndex: number) => (
        <div
          key={colIndex}
          className="v-table-cell d-flex align-items-center justify-content-center px-2"
          style={{ width: '150px', minWidth: '150px' }}
        >
          {isReadOnly ? (
            <span className="text-muted">
              {currencyFormat(rowValues?.[`month_${colIndex}`]?.amount || 0)}
            </span>
          ) : (
            <Controller
              name={`budgets.${rowIndex}.month_${colIndex}.amount`}
              control={control}
              render={({ field }) => (
                <InputGroup className="budget-amount-group w-100">
                  <InputGroup.Text className="px-2">$</InputGroup.Text>
                  <CurrencyInput
                    className="form-control budget-amount-input text-end"
                    placeholder="0.00"
                    value={field.value}
                    decimalsLimit={2}
                    onValueChange={(val) => {
                      field.onChange(val || 0)
                      onValueChange(rowIndex, colIndex, val || '0')
                    }}
                    decimalSeparator="."
                    allowDecimals={true}
                    groupSeparator=""
                    disableAbbreviations
                  />
                </InputGroup>
              )}
            />
          )}
        </div>
      ))}
      <div
        className="v-table-cell d-flex align-items-center justify-content-end pe-3 fw-bold flex-grow-1 text-black"
        style={{ width: '140px', minWidth: '140px' }}
      >
        {usdCurrencyFormat(rowTotal)}
      </div>
    </div>
  )
})

export default BudgetRow
